import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useWorkspace } from "@/context/WorkspaceContext";
import { apiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function Organizations() {
  const { orgs, createOrg, selectOrg, loading } = useWorkspace();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const create = async (e) => {
    e.preventDefault();
    if (busy || loading || !name.trim()) return;
    setBusy(true); setError("");
    try { await createOrg(name); setName(""); navigate("/dashboard/projects"); }
    catch (err) { setError(apiError(err)); }
    finally { setBusy(false); }
  };
  return <div className="space-y-6" data-testid="organizations-page">
    <div><h1 className="text-2xl font-semibold">{orgs.length ? "Mes organisations" : "Créez votre première organisation"}</h1>
      <p className="mt-2 text-sm text-zinc-400">Une organisation regroupe vos projets et votre équipe. Vous devenez propriétaire de celle que vous créez.</p></div>
    <form onSubmit={create} className="max-w-xl space-y-4 rounded-lg border border-zinc-800 p-5">
      <h2 className="font-medium">Nouvelle organisation</h2>
      <label className="block space-y-2 text-sm"><span>Nom de l’organisation</span><Input required maxLength={120} value={name} disabled={busy} onChange={(e) => setName(e.target.value)} placeholder="Mon entreprise" /></label>
      {error && <p role="alert" className="text-sm text-red-400">{error}</p>}
      <p className="text-xs text-zinc-400">Votre email doit être vérifié. <Link to="/dashboard/settings" className="underline">Vérifier mon compte ou renvoyer le lien</Link></p>
      <Button type="submit" disabled={busy || loading || !name.trim()}>{busy ? "Création…" : "Créer l’organisation"}</Button>
    </form>
    {orgs.length > 0 && <ul className="space-y-2">{orgs.map((org) => <li key={org.id} className="flex items-center justify-between rounded border border-zinc-800 p-3"><span>{org.name}</span><Button variant="outline" disabled={busy || loading} onClick={async () => { await selectOrg(org.id); navigate("/dashboard"); }}>Ouvrir</Button></li>)}</ul>}
  </div>;
}
